// extracted by mini-css-extract-plugin
export default {"closeBtn":"MarketGraphClosePageBtn_closeBtn__LB-eI","closeBtn__icon":"MarketGraphClosePageBtn_closeBtn__icon__20l-h"};